// Centralised date / datetime formatting helpers.
//
// The whole UI must always show dates as day/month/year (dd/mm/yyyy)
// — never the US month/day/year ordering — so every component that needs
// to render a date string should funnel through these helpers instead of
// calling `toLocaleDateString` directly.

function pad(n) { return String(n).padStart(2, '0'); }

export function formatDate(input) {
  if (!input && input !== 0) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

export function formatDateTime(input) {
  if (!input && input !== 0) return '';
  const d = input instanceof Date ? input : new Date(input);
  if (isNaN(d.getTime())) return '';
  return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
